module.exports = __webpack_public_path__ + "static_pc/img/cosn2.e6915a25.png";